/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ReactNode } from "react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";

export default function ErrorBoundary(): ReactNode {
    const error = useRouteError();

    console.error(error);

    let errorMessage: string;
    let stackMessage = "No Stack";

    if (isRouteErrorResponse(error)) {
        // error is type `ErrorResponse`

        errorMessage = error.data?.message ?? error.statusText;
        stackMessage = error.data?.stack ?? "No stack";
    } else if (error instanceof Error) {
        errorMessage = error.message;
        stackMessage = error.stack ?? "No stack";
    } else if (typeof error === "string") {
        errorMessage = error;
    } else {
        errorMessage = "Unknown error";
    }

    return (
        <section
            className="flex flex-col gap-2.5 justify-center items-center min-h-full"
            style={{ background: "#F2F5F7" }}
        >
            <p>
                An Error has occured. Please check console. and send a screenshot of
                this page to the owner.
            </p>
            <p className="text-slate-400">{errorMessage}</p>
            <p className="text-slate-400">{stackMessage}</p>
        </section>
    );
}
